import { doGet, doPost, doPut } from '@/tools/axios'

export default {
  getUnitedGroup (id, rankingWeek) {
    return doGet(`/unitedGroups/${id}` + (rankingWeek ? `?ranking_week=${encodeURIComponent(rankingWeek)}` : ''))
  },
  getCarbonLabellingUsers (groupId, page, perPage = 20) {
    return doGet(`/carbonLabelling/${groupId}/users?page=${page}&perPage=${perPage}`)
  },
  addCarbonLabellingUser (groupId, userId) {
    return doPost(`/carbonLabelling/${groupId}/addUser`, { user_id: userId })
  },
  removeCarbonLabellingUser (groupId, groupUserId) {
    return doPost(`/carbonLabelling/${groupId}/removeUser`, { group_user_id: groupUserId })
  },
  bulkRemoveCarbonLabellingUsers (groupId, groupUserIds) {
    return doPost(`/carbonLabelling/${groupId}/removeUsers`, { group_user_ids: groupUserIds })
  },
  getCarbonLabellingGroup (groupId) {
    return doGet(`/carbonLabelling/${groupId}`)
  },
  getCarbonLabellingUserInfo (groupUserId) {
    return doGet(`/carbon_labelling_group_users/${groupUserId}`)
  },
  acceptCarbonLabellingUser (groupUserId, employeeNo, name) {
    return doPost(`/carbon_labelling_group_users/${groupUserId}/accept`, { employee_no: employeeNo, name })
  },
  rejectCarbonLabellingUser (groupUserId) {
    return doPost(`/carbon_labelling_group_users/${groupUserId}/reject`)
  },
  quitCarbonLabellingGroup (groupUserId) {
    return doPost(`/carbon_labelling_group_users/${groupUserId}/quit`)
  },
  getMyCarbonLabellingGroupInfos () {
    return doGet('/carbon_labelling_group_users')
  },
  getMyCarbonLabellingInfluence (groupUserId, startDate, endDate) {
    return doGet(`/carbon_labelling_group_users/${groupUserId}/influence`, {
      start_date: startDate,
      end_date: endDate
    })
  },
  updateCarbonLabellingGroupUser (groupUserId, data) {
    return doPut(`/carbon_labelling_group_users/${groupUserId}`, data)
  },
  getMemberChanges (groupId, { type = 'join', page = 1, perPage = 20 } = {}) {
    return doGet(`/carbonLabelling/${groupId}/memberChange`, {
      type,
      page,
      perPage
    })
  },
  getCarbonLabellingAnnouncements (groupId, page = 1, perPage = 20) {
    return doGet(`/carbonLabelling/${groupId}/announcements`, {
      page,
      perPage
    })
  },
  publishCarbonLabellingAnnouncement (groupId, data) {
    return doPost(`/carbonLabelling/${groupId}/announcements/publish`, data)
  }
}
